import { FC, useEffect, useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import { MdLockOpen } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IAssessment, openUrl } from '@bemap/utils';
import { Container, PageWrapper } from './answer-assessment-styles';
import { getAssessmentById, unlock } from './answer-assessment-service';
import { Logo, LoadingScreen } from '@bemap/ui';

const AnswerAssessmentThanks: FC = () => {
  const { t } = useTranslation()
  const { hash } = useParams()

  const initialAssessment: IAssessment = {
    team_id: 0,
    report_id: 1,
    profile: {
      name: 'Carregando...',
      email: 'carregando...'
    }
  }

  const [assessment, setAssessment] = useState<IAssessment>(initialAssessment);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [answered, setAnswered] = useState<boolean>(false);
  const [logo, setLogo] = useState<string>();
  useEffect(() => {
    loadAssessment();
  }, []);

  async function loadAssessment() {
    setIsLoading(true);
    try {
      const response = await getAssessmentById(hash || '');
      setAssessment(response.message?.assessment);
      setAnswered(response.message?.answered);
      setLogo(response.message?.logo);
      setIsLoading(false);
    } catch (error) {
      setAssessment(initialAssessment);
      setIsLoading(false);
    }
  }

  async function unlockAsClient() {
    setIsSaving(true);
    try {
      const response = await unlock(hash || '');
      openUrl(response.message)
      setIsSaving(false);
    } catch (error) {
      setAssessment(initialAssessment);
      setIsSaving(false);
    }
  }

  if (isLoading) {
    return (
      <Box h={'100vh'} w={'100vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
        <LoadingScreen />
      </Box>
    )
  }

  return (
    <PageWrapper>
      <Container>
        <Flex w='100%' alignItems={'center'} justifyContent={'center'}>
          <Logo url={logo} />
        </Flex>
        <Flex mt='20px' justifyContent={'center'} fontSize={'1.3rem'}>
          {answered ? t('answer_assessment.thanks_text') : t('answer_assessment.not_answered')}
        </Flex>
        {assessment.client_can_unlock && answered && (
          <Button leftIcon={<MdLockOpen />} onClick={unlockAsClient} variant='solid' colorScheme={'blue'} isLoading={isSaving} disabled={!assessment.client_can_unlock}>
            {t('answer_assessment.unlock')}
          </Button>
        )}
      </Container>
    </PageWrapper>
  )
};

export default AnswerAssessmentThanks;
